
export function useShowNoteButton() {
    const handleShowNoteButton = (context) => {
        if (["/nfe/issuer"].includes(location.pathname)) {
            if (context.currentBranch) {
                if (context.currentBranch.branch_plan) {
                    const branchPlan = context.currentBranch.branch_plan
                    if (branchPlan.id == "57664246-1822-4f43-bbb9-6fcdad8eb307") {
                        return false
                    }
                    return branchPlan.id !== "b85046a1-3803-4ee4-a858-8ef2c26d9d76"
                } 
                else {
                    return false;
                }
            } else {
                return false;
            }
        } else {
            return false;
        }
    };
    return handleShowNoteButton;
}



// WEBPACK FOOTER //
// ./src/views/AppViews/Plans/NotesQuantityIcon/hooks/index.js